import { m } from "framer-motion";

interface ContextIndicatorProps {
  sessionCount: number;
  projectCount: number;
  isLoading?: boolean;
  hasFilters?: boolean;
  onClick?: () => void;
}

const ContextIndicator = ({
  sessionCount,
  projectCount,
  isLoading = false,
  hasFilters = false,
  onClick,
}: ContextIndicatorProps) => {
  const baseClasses = "text-xs text-muted-foreground";
  const clickableClasses = onClick
    ? "cursor-pointer hover:text-foreground transition-colors"
    : "";

  if (isLoading) {
    return (
      <div
        className={`text-xs text-muted-foreground ${onClick ? "cursor-pointer" : ""}`}
        onClick={onClick}
      >
        Loading context...
      </div>
    );
  }

  // Show "All projects" when no filters are applied
  if (!hasFilters) {
    return (
      <m.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className={`${baseClasses} ${clickableClasses}`}
        onClick={onClick}
      >
        All projects
      </m.div>
    );
  }

  // Don't show anything if we have no data when filters are applied
  if (sessionCount === 0) {
    return (
      <div
        className={`text-xs text-muted-foreground ${onClick ? "cursor-pointer" : ""}`}
        onClick={onClick}
      >
        No sessions available
      </div>
    );
  }

  return (
    <m.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className={`${baseClasses} ${clickableClasses}`}
      onClick={onClick}
    >
      {sessionCount.toLocaleString()}{" "}
      {sessionCount === 1 ? "session" : "sessions"}
      {projectCount > 0 && (
        <>
          {" "}
          across {projectCount} {projectCount === 1 ? "project" : "projects"}
        </>
      )}
    </m.div>
  );
};

export default ContextIndicator;
